import { defineProductDimensions, nlRcphPricingVersionDimension, nlRcphSelectedDimension } from '@orus.eu/dimensions'

import { nlRcphProductVersionDimension } from './nl-rcph-dimensions.ts'
import { nlRcphQuoteDimension } from './nl-rcph-quote-dimension.ts'

export * from './kvk-search-ui-element.ts'
export * from './nl-rcph-activity-dimensions.ts'
export * from './nl-rcph-dimensions.ts'
export * from './nl-rcph-policy-item-dimension.ts'
export * from './nl-rcph-quote-dimension.ts'
export * from './nl-rcph-subscription-ui.ts'
export * from './nl-rcph-subsidiaries-dimension.ts'
export * from './nl-rcph-ui-elements.ts'

export const nlRcphDimensionsModule = defineProductDimensions({
  product: 'nl-rcph',
  family: null,
  selectionDimension: nlRcphSelectedDimension,
  productVersionDimension: nlRcphProductVersionDimension,
  pricingVersionDimension: nlRcphPricingVersionDimension,
  quoteV3Dimension: nlRcphQuoteDimension,
})
